import img0 from "./Assets/0.png";
import img1 from "./Assets/1.png";
import img2 from "./Assets/2.png";
import img3 from "./Assets/3.png";
import img4 from "./Assets/4.png";
import img5 from "./Assets/5.png";
import img6 from "./Assets/6.png";
import img7 from "./Assets/7.png";
import img8 from "./Assets/8.png";
import img9 from "./Assets/9.png";
import img10 from "./Assets/10.png";
import img11 from "./Assets/11.png";
import img12 from "./Assets/12.png";
import img13 from "./Assets/13.png";
import img14 from "./Assets/14.png";
import img15 from "./Assets/15.png";
import img16 from "./Assets/16.png";
import img17 from "./Assets/17.png";
import img18 from "./Assets/18.png";
import img19 from "./Assets/19.png";
import logo from "./Assets/pspb.png";

export default class PowerStrikePowerBallsConfig {
    constructor() {
        // Set up the symbol imgs & Logo
        // Make sure to match with imports above
        this.symbolImgs = [img0, img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17, img18, img19];
        this.logo = logo;

        //Game Name
        this.name = "Power Strike Power Balls";

        //General Config
        this.reels = 3;
        this.symbolPerReel = 3;
        this.cascade = false;

        //This is used to invert the symbol IDs (because Aris). Input the highest symbol ID possible in the game.
        //Have left this to be a manual input as sometimes it can work slightly differently depending on game
        this.highestSymId = 19;

        //Ask CROW for the maths object
        this.maths = this.getMaths();
    }

    getMaths() {
        //paste what crow gives you here!
        return {
            94:{
                reductionWeight1M: 6114
            },
            95: {
                weights: {
                    baseGame: [250, 33000, 5000, 5000, 9000],
                    freeSpins: {
                        f: [3575, 12870, 9438, 4368, 1820, 560, 120, 16, 1]
                    },
                },
                reelSets: {
                    0: [
                        [4, 4, 3, 3, 2, 2, 3, 0, 3, 0, 2, 2, 0, 0, 4, 2, 4, 3, 0, 5, 5, 3, 0, 0, 2, 0, 3, 2, 0, 2, 5, 7, 2, 2, 7, 4, 4, 0, 5, 4, 7, 0, 3, 3],
                        [3, 3, 4, 4, 0, 1, 1, 3, 0, 8, 1, 1, 3, 3, 5, 3, 1, 0, 3, 1, 6, 0, 3, 0, 0, 6, 8, 1, 4, 1, 1, 0, 1, 0, 0, 8, 8, 0, 5, 3, 6, 5, 5, 0, 4, 4],
                        [2, 1, 1, 2, 6, 2, 4, 1, 2, 2, 1, 5, 8, 0, 1, 1, 4, 2, 1, 8, 4, 6, 2, 1, 5, 7, 5, 5, 8, 2, 1, 7, 1, 2, 2, 6, 8, 4, 4, 0],
                    ],
                    1: [
                        [1, 5, 6, 1, 5, 3, 5, 5, 3, 3, 6, 3, 3, 3, 8, 8, 3, 3, 3, 7, 7, 3, 3, 3, 1, 6, 4, 4, 1, 1, 4, 1, 3, 3, 4, 4, 1, 1, 1, 6, 5, 1, 1, 1, 4, 4, 4, 3, 7, 1, 1, 1, 4, 7, 3, 3, 3, 6, 6, 5, 5, 4, 1, 7, 7, 1, 1, 1, 8, 5, 1, 1, 3, 1, 1, 1, 3, 1, 8, 7, 8],
                        [1, 5, 6, 1, 5, 3, 5, 5, 3, 3, 6, 3, 3, 3, 8, 8, 3, 3, 3, 7, 7, 3, 3, 3, 1, 6, 4, 4, 1, 1, 4, 1, 3, 3, 4, 4, 1, 1, 1, 6, 5, 1, 1, 1, 4, 4, 4, 3, 7, 1, 1, 1, 4, 7, 3, 3, 3, 6, 6, 5, 5, 4, 1, 7, 7, 1, 1, 1, 8, 5, 1, 1, 3, 1, 1, 1, 3, 1, 8, 7, 8],
                        [1, 5, 6, 1, 5, 3, 5, 5, 3, 3, 6, 3, 3, 3, 8, 8, 3, 3, 3, 7, 7, 3, 3, 3, 1, 6, 4, 4, 1, 1, 4, 1, 3, 3, 4, 4, 1, 1, 1, 6, 5, 1, 1, 1, 4, 4, 4, 3, 7, 1, 1, 1, 4, 7, 3, 3, 3, 6, 6, 5, 5, 4, 1, 7, 7, 1, 1, 1, 8, 5, 1, 1, 3, 1, 1, 1, 3, 1, 8, 7, 8],
                    ],
                    2: [
                        [7, 10, 3, 3, 10, 4, 2, 10, 7, 1, 1, 1, 5, 10, 4, 4, 3, 3, 10, 7, 5, 5, 3, 5, 10, 6, 3, 3, 10, 1, 1, 10, 1, 1, 10, 3, 1, 1, 1, 8],
                        [7, 2, 2, 7, 6, 5, 1, 1, 1, 2, 2, 2, 6, 2, 2, 1, 1, 4, 4, 1, 1, 1, 7, 4, 4, 4, 3, 4, 4, 2, 2, 2, 8, 1, 1, 4, 6],
                        [7, 10, 6, 3, 10, 2, 2, 2, 6, 1, 5, 10, 3, 6, 4, 10, 2, 2, 10, 3, 3, 5, 5, 10, 2, 2, 10, 2, 2, 2, 10, 3, 3, 3, 10, 5, 3, 8],
                    ],
                    3: [
                        [7, 19, 3, 3, 19, 4, 2, 19, 7, 0, 0, 0, 19, 8, 4, 4, 3, 3, 19, 7, 5, 5, 3, 5, 19, 6, 3, 3, 19, 0, 0, 19, 0, 0, 19, 3, 0, 0, 0, 5],
                        [7, 2, 2, 7, 6, 5, 0, 0, 0, 2, 2, 2, 6, 2, 2, 0, 0, 4, 4, 0, 0, 0, 7, 4, 4, 4, 3, 4, 4, 2, 2, 2, 8, 0, 0, 4, 6],
                        [7, 19, 6, 3, 19, 2, 2, 2, 6, 0, 5, 19, 3, 4, 19, 6, 2, 2, 19, 3, 3, 5, 5, 19, 2, 2, 19, 2, 2, 2, 19, 3, 3, 3, 19, 5, 3, 8],
                    ],
                    4: [
                        [0, 0, 9, 3, 3, 1, 1, 6, 3, 8, 3, 3, 6, 6, 7, 1, 1, 4, 9, 4, 8, 1, 1, 1, 9, 0, 0, 4, 4, 9, 1, 1, 6, 9, 4, 4, 0, 0, 0, 5, 0, 0, 6, 4, 5, 0, 0, 0, 2, 5, 2, 2, 9, 3, 3, 3, 5, 5, 9, 3, 5, 5, 3, 9, 2, 2, 2, 0, 0, 6, 8, 2, 2, 7, 2, 2, 9, 7, 0, 9, 1, 1, 1],
                        [1, 1, 1, 3, 3, 7, 4, 4, 0, 9, 1, 1, 3, 6, 6, 2, 2, 2, 6, 5, 5, 8, 0, 0, 7, 9, 4, 7, 5, 8, 3, 3, 3, 9, 1, 1, 6, 2, 0, 0, 0, 9, 0, 0, 3, 3, 9, 5, 5, 2, 2, 5, 9, 8, 0, 0, 5, 2, 9, 1, 1, 1, 4, 4, 4, 3, 9, 0, 0, 0, 9, 2, 2, 1, 1, 4, 7, 0, 0, 9, 3, 6, 9],
                        [3, 3, 4, 4, 3, 3, 0, 0, 6, 6, 3, 0, 0, 0, 4, 9, 6, 7, 1, 1, 5, 1, 1, 1, 5, 5, 7, 2, 2, 9, 7, 8, 2, 2, 4, 4, 5, 3, 3, 3, 0, 0, 0, 8, 9, 2, 2, 2, 6, 3, 9, 1, 1, 1, 2, 3, 7, 0, 0, 9, 0, 0, 9, 1, 5, 5, 9, 4, 4, 5, 9, 8, 1, 1, 9, 0, 0, 0, 2, 2, 9, 0, 0],
                    ],
                    f_0: [
                        [11, 11, 11, 11, 11, 11],
                        [11, 11, 11, 11, 11, 11],
                        [11, 11, 11, 11, 11, 11],
                    ],
                    f_1: [
                        [11, 12, 11, 11, 12, 11],
                        [11, 12, 11, 11, 12, 11],
                        [11, 11, 11, 11, 11, 11],
                    ],
                    f_2: [
                        [11, 13, 11, 11, 13, 11],
                        [11, 13, 11, 11, 13, 11],
                        [11, 11, 11, 11, 11, 11],
                    ],
                    f_3: [
                        [12, 12, 12, 12, 12, 12],
                        [12, 12, 12, 12, 12, 12],
                        [11, 11, 11, 11, 11, 11],
                    ],
                    f_4: [
                        [14, 14, 14, 14, 14, 14],
                        [14, 14, 14, 14, 14, 14],
                        [11, 11, 11, 11, 11, 11],
                    ],
                    f_5: [
                        [15, 15, 15, 15, 15, 15],
                        [15, 15, 15, 15, 15, 15],
                        [11, 11, 11, 11, 11, 11],
                    ],
                    f_6: [
                        [16, 16, 16, 16, 16, 16],
                        [16, 16, 16, 16, 16, 16],
                        [11, 11, 11, 11, 11, 11],
                    ],
                    f_7: [
                        [17, 17, 17, 17, 17, 17],
                        [17, 17, 17, 17, 17, 17],
                        [11, 11, 11, 11, 11, 11],
                    ],
                    f_8: [
                        [18, 18, 18, 18, 18, 18],
                        [18, 18, 18, 18, 18, 18],
                        [11, 11, 11, 11, 11, 11],
                    ],
                },
            },
        };
    }
}
